<script lang="ts">
import FichePaie from '@/generated/fiches/FichePaie.vue';
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  extends: FichePaie
})

</script>
